export default __webpack_public_path__ + "static/media/icon-energy-bg.c57260a1.jpg";